<template>
    <div class="B2BReviewCard bg-white dark:bg-surface-card xl:h-[429px] xl:max-w-xl xl:rounded-2xl">
        <div class="flex h-full flex-col px-12 py-14">
            <div class="flex flex-col-reverse gap-4 xl:flex-row xl:justify-between">
                <h3 class="text-left text-2xl font-black text-black dark:text-txt-headings">{{ review?.title }}</h3>
                <CButton
                    class="mb-11 h-10 w-24"
                    :class="{
                        'bg-primary-200 dark:bg-primary-950/40 text-blue-800 dark:text-blue-300 hover:bg-[#D4EAFD]': review?.type === 'Firma',
                        'bg-secondary-100 dark:bg-secondary-950/40 text-secondary-830 dark:text-secondary-300 hover:bg-[#FBE5D1]': review?.type === 'Štát'
                    }"
                    :href="review?.link"
                    target="_blank"
                    :variant="review?.type === 'Neziskovka' ? 'primary-150' : 'default'"
                >
                    {{ review?.type }}
                </CButton>
            </div>

            <CText variant="muted">
                {{ review?.message }}
            </CText>

            <div class="mt-auto flex flex-row pt-4">
                <img alt="profilovka" class="size-12 rounded-full object-cover" :src="review?.img" />
                <div class="ml-4 flex flex-col">
                    <CText>{{ review?.name }}</CText>
                    <CText v-if="review?.job" class="text-sm" variant="muted">
                        {{ review?.job }}
                    </CText>
                    <CText v-else class="text-sm" variant="muted">
                        {{ review?.type }}
                    </CText>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import CText from '@/components/ui/CText.vue'

interface Review {
    title?: string
    type?: string
    link?: string
    message?: string
    img?: string
    name?: string
    job?: string
}

defineProps({
    review: {
        type: Object as () => Review,
        default: () => ({})
    }
})
</script>
